import React from "react";
import "../css/listautiles.css";

const ListaUtiles = () => {

  const listas = [

    {
      titulo: "Pre-Kínder",
      imagen: "/imagenes/listasutiles/pre-kinder.jpg",
      pdf: "/pdfs/LISTA  PKINDER 2026.pdf",
    },

    {
      titulo: "Kínder",
      imagen: "/imagenes/listasutiles/kinder.jpg",
      pdf: "/pdfs/LISTA KÍNDER 2026.pdf",
    },

    {
      titulo: "1° Año Básico",
      imagen: "/imagenes/listasutiles/1basico.jpg",
      pdf: "/pdfs/LISTA 1 2026.pdf",
    },

    {
      titulo: "2° Año Básico",
      imagen: "/imagenes/listasutiles/2basico.jpg",
      pdf: "/pdfs/LISTA 2 2026.pdf",
    },

    {
      titulo: "3° y 4° Año Básico",
      imagen: "/imagenes/listasutiles/3y4basico.jpg",
      pdf: "/pdfs/LISTA 3y4 2026.pdf",
    },

    {
      titulo: "5° a 8° Año Básico",
      imagen: "/imagenes/listasutiles/5a8basico.jpg",
      pdf: "/pdfs/LISTA 5y8 2026.pdf",
    },

  ];

  return (

    <section id="listacursos" className="utiles-container">

      <div className="utiles-header">

        <h2 className="utiles-title">

          Lista de Útiles Escolares 2026

        </h2>

        <p className="utiles-subtitle">

          Seleccione el nivel correspondiente para visualizar y descargar la lista oficial de útiles escolares.

        </p>

      </div>

      <div className="utiles-grid">

        {

          listas.map((lista, index) => (

            <a

              key={index}

              href={lista.pdf}

              target="_blank"

              rel="noopener noreferrer"

              className="util-card"

            >

              <div className="util-image-wrapper">

                <img

                  src={lista.imagen}

                  alt={lista.titulo}

                  className="util-image"

                />

              </div>

            </a>

          ))

        }

      </div>

    </section>

  );

};

export default ListaUtiles;